import type { FC } from 'react'
import type { ChargingAction } from '../../types/charging-steering.types'
import { Button } from '../Buttons/Button'
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator'

type ActionButtonsProps = {
  disableActionButtons: boolean
  actionLoading: ChargingAction | null
  onStart: () => void
  onStop: () => void
}

export const ActionButtons: FC<ActionButtonsProps> = ({
  disableActionButtons,
  actionLoading,
  onStart,
  onStop,
}) => {
  return (
    <section className="actions-page-actions-wrapper">
      <Button onClick={onStart} variant="primary" disabled={disableActionButtons}>
        {actionLoading === 'start' ? <LoadingIndicator style="INLINE" /> : 'Start'}
      </Button>

      <Button onClick={onStop} variant="primary" disabled={disableActionButtons}>
        {actionLoading === 'stop' ? <LoadingIndicator style="INLINE" /> : 'Stop'}
      </Button>
    </section>
  )
}
